import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';
import { AbstractControl } from '@angular/forms';
import { Observable, of } from 'rxjs';

/**
 * Simplified Formly extension that triggers batch async validation through DetailsService
 * Replaces complex field-level validation orchestration with simple trigger mechanism
 */
export const asyncValidationExtension: FormlyExtension = {
  postPopulate(field: FormlyFieldConfig): void {
    // Early return if field is not marked for async validation
    if (!field.props?.enableAsyncValidation || !field.formControl) {
      return;
    }

    const detailsService = field.options?.formState?.detailsService;
    if (!detailsService) {
      return;
    }

    // Set up simple async validator that triggers batch validation
    field.formControl.setAsyncValidators([
      (control: AbstractControl): Observable<null> => {
        // Skip validation if field is pristine
        if (control.pristine) {
          return of(null);
        }

        // Trigger batch validation in DetailsService
        // DetailsService handles all the complexity: collecting dirty fields,
        // debouncing, API calls, and updating validation status
        detailsService.triggerAsyncValidation();

        // Always return null - DetailsService manages validation state
        // Individual fields don't show errors, form-level blocking is handled by DetailsService
        return of(null);
      },
    ]);
  },
};

export const asyncValidationExtensionConfig = {
  name: 'asyncValidation',
  extension: asyncValidationExtension,
};
